export const GET_USER_DETAILS = 'GET_USER_DETAILS'
export const SET_USERS = 'SET_USERS'
export const SET_SELECTED_USER = 'SET_SELECTED_USER'
